import React from 'react';
import { Selector } from './Selector/Selector';
import { useSettings } from '../../../../providers/SettingsProvider';
import { useTexts } from '../../../../useTexts';
const OFF_VALUE = '__off__';
export const SubtitlesSelector = ({ visible, onBackButtonClick }) => {
    const { menuSubtitlesTitle, subtitlesOffLabel } = useTexts();
    const { subtitlesState } = useSettings();
    if (!subtitlesState) {
        return null;
    }
    const { options, selectedValue, enabled, setSelectedValue, setEnabled } = subtitlesState;
    const selectorOptions = [
        { value: OFF_VALUE, displayText: subtitlesOffLabel },
        ...options.map((o) => ({ value: o.value, displayText: o.displayText })),
    ];
    const currentSelectedValue = enabled && selectedValue ? selectedValue : OFF_VALUE;
    const handleSelect = (value) => {
        if (value === OFF_VALUE) {
            setEnabled(false);
        }
        else {
            setSelectedValue(value);
        }
    };
    return (React.createElement(Selector, { visible: visible, onBackButtonClick: onBackButtonClick, options: selectorOptions, onSelect: handleSelect, selectedValue: currentSelectedValue, backButtonText: menuSubtitlesTitle }));
};
//# sourceMappingURL=SubtitlesSelector.js.map